

// Import ----------------------------------------------------------------------

// Project
import { ContentImageMeta, VueGlobalInjectable } from "~/libs/Types";
import Utils, { NodeMedia } from "~/libs/Utils";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    computed: {
        wrapperType (): string {
            return this.hasLink ? "nuxt-link" : "span";
        },

        imageSrc (): string {
            return Utils.nodeMediaUrl(this.node, NodeMedia.Image);
        },

        hasLink () : boolean {
            return this.imageLink.length > 0;
        },

        imageLink (): string {
            return this.node.page?.imageLink ?? "";
        },

        mediaMeta (): ContentImageMeta {
            return Utils.nodeMediaMeta(this.node);
        }
    }

    // -------------------------------------------------------------------------
});
